(() => {
  function pickerFor(formId) {
    return [...document.querySelectorAll('variant-picker[form-id]')]
      .find(picker => picker.getAttribute('form-id') === formId);
  }

  function requiredFields(picker) {
    return [...picker.querySelectorAll('fieldset.variant-picker__option')]
      .map(fieldset => ({
        fieldset,
        button: fieldset.querySelector('button.select'),
        inputs: [...fieldset.querySelectorAll('input[type="radio"][data-option-position]')]
      }))
      .filter(field => field.button && field.inputs.length > 1);
  }

  function isMissing(field) {
    const text = field.button.textContent.trim().toLowerCase();
    return text.startsWith('scegli ') || text.startsWith('seleziona ');
  }

  function clearError(fieldset) {
    fieldset.querySelector('.mami-option-error')?.remove();
  }

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const fieldset = target.closest('fieldset.variant-picker__option');
    if (!fieldset) return;
    if (target.closest('label[for], input[type="radio"][data-option-position]')) {
      setTimeout(() => clearError(fieldset), 0);
    }
  });

  document.addEventListener('change', event => {
    const target = event.target;
    if (target instanceof Element) {
      const fieldset = target.closest('fieldset.variant-picker__option');
      if (fieldset) clearError(fieldset);
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const formId = form.getAttribute('id');
    if (!formId) return;

    const picker = pickerFor(formId);
    if (!picker) return;

    const fields = requiredFields(picker);
    fields.forEach(field => {
      if (!isMissing(field)) clearError(field.fieldset);
    });

    const missing = fields.filter(isMissing);
    if (!missing.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    missing.forEach(({ fieldset }) => {
      let error = fieldset.querySelector('.mami-option-error');
      if (!error) {
        error = document.createElement('p');
        error.className = 'mami-option-error';
        error.setAttribute('role', 'alert');
        fieldset.appendChild(error);
      }
      const legend = fieldset.querySelector('legend')?.textContent?.trim().replace(/:$/, '') || 'opzione';
      error.textContent = 'Seleziona ' + legend.toLowerCase() + ' dal menu prima di aggiungere al carrello.';
    });

    missing[0].button.focus();
    missing[0].button.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
})();